import { db } from '../store/firebase'

export function unsubscribe(collection) {
  const unsub = db.collection(collection)
    .onSnapshot(function() {})
  unsub()
}
